import { cn } from '@/lib/utils'

interface CalendarEmptyIconProps {
  className?: string
}

const CalendarEmptyIcon = ({ className }: CalendarEmptyIconProps) => {
  return (
    <svg className={cn('h-12 w-12 text-slate-300', className)} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  )
}

export default CalendarEmptyIcon
